import { ArrowUpRight, ChartCandlestick, Waves } from "lucide-react";

const PlatformMark = ({ platform, placement }) => {
  if (platform.image) return <img src={platform.image} alt="" aria-hidden="true" width="48" height="48" loading="lazy" decoding="async" data-testid={`${placement}-platform-${platform.id}-logo`} />;
  const Icon = platform.id === "orca" ? Waves : ChartCandlestick;
  return <span className={`platform-mark platform-mark--${platform.id}`} aria-hidden="true" data-testid={`${placement}-platform-${platform.id}-logo`}><Icon /></span>;
};

export const PlatformLinks = ({ platforms, placement = "home", title = "ACCESS $KBULL" }) => (
  <section className={`platform-links platform-links--${placement}`} aria-labelledby={`${placement}-platform-links-heading`} data-testid={`${placement}-platform-links`}>
    <p className="platform-links__label" id={`${placement}-platform-links-heading`} data-testid={`${placement}-platform-links-heading`}>{title}</p>
    <div className="platform-links__grid">
      {platforms.map((platform) => (
        <a
          key={platform.id}
          href={platform.url}
          target="_blank"
          rel="noopener noreferrer"
          className="platform-link"
          data-testid={`${placement}-platform-${platform.id}-link`}
          data-token-specific={platform.tokenSpecific || undefined}
        >
          <PlatformMark platform={platform} placement={placement} />
          <span data-testid={`${placement}-platform-${platform.id}-name`}>{platform.name}</span>
          <ArrowUpRight aria-hidden="true" />
        </a>
      ))}
    </div>
  </section>
);

export const BuyPlatformMark = ({ platform }) => <PlatformMark platform={platform} placement="buy" />;